import { render, staticRenderFns } from "./CourseAttendanceDutyDeduction.vue?vue&type=template&id=edbabb9e&scoped=true"
import script from "./CourseAttendanceDutyDeduction.vue?vue&type=script&lang=js"
export * from "./CourseAttendanceDutyDeduction.vue?vue&type=script&lang=js"
import style0 from "./CourseAttendanceDutyDeduction.vue?vue&type=style&index=0&id=edbabb9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edbabb9e",
  null
  
)

export default component.exports